<template>
	<button aria-label="Print Page" v-on:click="printPage()"><font-awesome-icon icon="print" /></button>
</template>

<script>
	import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome';

	export default {
		name: 'PrintIcon',
		methods: {
			printPage() {
				window.print();
			}
		},
		components: {
			FontAwesomeIcon
		}
	}
</script>

<style lang="scss" scoped>
	button {
		border: 0;
		background: none;
		padding: 0;
		margin: 0;
		position: absolute;
		right: 33px;
		top: 9px;
		color: #525252;
		cursor: pointer;
	}

	svg {
		width: 20px !important;
		height: 20px !important;
	}
</style>
